import { useClient, useQuery } from "jsonapi-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { API_BASE_URL, apiRoutes, VW_ROUTES } from "../../constants";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import { AppContext } from "../../context/AppContext";
import Select from "react-select";
import {
  checkModuleGeneralPermission,
  formatTextWithFallback,
  getCurrentWindowParams,
  getFormattedDateTime,
  getLocalDateTime,
} from "../../helpers/helpers";
import axios from "axios";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import ContextMenuContentWrapper from "../../components/common/ContextMenuContentWrapper";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import { useToasts } from "react-toast-notifications";
import SearchBar from "../../components/common/Search/Search";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import PillText from "../../components/PillText/PillText";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Title } from "chart.js";
import ReactTooltip from "react-tooltip";

const PublicRegistrationRecipients = () => {
  const { userRoleDetails } = useContext(AppContext);
  const { addToast } = useToasts();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currPage, setCurrPage] = useState(1);
  const [activePage, setactivePage] = React.useState(1);
  const [profileActivePage, setProfileActivePage] = React.useState(1);
  const [profilesPage, setProfilesPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const windowParams = getCurrentWindowParams();
  const [totalCount, setTotalCount] = useState();
  const [inviteId, setInviteId] = useState("");
  const [recipientId, setRecipientId] = useState(null);
  const [inviteDetails, setInviteDetails] = useState();
  const [searchQueryString, setSearchQueryString] = useState(null);
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);
  const [filterApplied, setFilterApplied] = React.useState(false);
  const [selectedDetails, setSelectedDetails] = useState();
  const [showResendConfirmation, setResendConfirmation] = useState(false);
  const [showBlockConfirmation, setBlockConfirmation] = useState(false);
  const [blockedFilter, setIsBlockedFilter] = useState();
  const [showProfilesList, setShowProfilesList] = useState(false);
  const [profilesList, setProfilesList] = useState();
  const [profilesLoading, setProfilesLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    is_blocked: "",
  });

  const token = localStorage.getItem("access_token");

  const config = {
    headers: {
      Authorization: `JWT ${token}`,
    },
  };

  useEffect(() => {
    setInviteId(windowParams.get("id") || "");
  }, [windowParams]);

  const history = useHistory();

  const client = useClient();

  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  useEffect(() => {
    if (inviteId) {
      getInviteDetails();
    }
  }, [inviteId]);

  const getInviteDetails = () => {
    setLoading(true);
    let apiUrl;
    apiUrl = `${API_BASE_URL}${apiRoutes.publicRegisterInvite}/${inviteId}`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        if (res?.data?.data?.attributes?.description === "") {
          history.push({
            pathname: VW_ROUTES.PROFILE_NOT_FOUND,
          });
        }
        setInviteDetails(res?.data?.data);
        setLoading(false);
      })
      .catch(() => {
        history.push({
          pathname: VW_ROUTES.PROFILE_NOT_FOUND,
        });
        setLoading(false);
      });
  };

  const recipientsList = useQuery(
    inviteId && [
      apiRoutes.publicRegisterRecipientsList.replace("{inviteId}", inviteId),
      {
        filter: {
          ...(filters.search && { search: filters.search }),
          ...(filters.is_blocked !== "" && {
            is_blocked: filters.is_blocked,
          }),
        },
        page: {
          number: currPage,
          size: rowsPerPage,
        },
      },
    ],
    { client }
  );

  React.useEffect(() => {
    if (blockedFilter) {
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }
  }, [blockedFilter]);

  const openResendConfirmationModal = (data) => {
    setResendConfirmation(true);
    setSelectedDetails(data);
  };
  const openBlockConfirmationModaL = (data) => {
    setBlockConfirmation(true);
    setSelectedDetails(data);
  };
  const closeResendConfirmationModal = () => {
    setResendConfirmation(false);
    setSelectedDetails(null);
  };
  const closeBlockConfirmationModal = () => {
    setBlockConfirmation(false);
    setSelectedDetails(null);
  };

  const handleResendRecipientInvite = (data) => {
    closeResendConfirmationModal();
    if (!data) return;
    let apiUrl;
    apiUrl = `${API_BASE_URL}${apiRoutes.publicRegisterRecipientResend
      .replace("{inviteId}", inviteId)
      .replace("{recipientId}", data)}`;
    axios
      .post(apiUrl, {}, config)
      .then((res) => {
        addToast(
          res?.data?.data?.message ??
            DISPLAY_TEXTS.RECIPIENT_INVITE_RESEND_SUCESS,
          { appearance: "success" }
        );
        recipientsList?.refetch && recipientsList.refetch();
      })
      .catch((err) => {
        addToast(
          err?.response?.data?.errors[0]?.detail ??
            DISPLAY_TEXTS.RECIPIENT_INVITE_RESEND_FAILED,
          { appearance: "error" }
        );
      });
  };

  const handleBlockRecipientInvite = (data) => {
    closeBlockConfirmationModal();
    if (!data) return;
    let apiUrl;
    if (data?.isBlocked) {
      apiUrl = `${API_BASE_URL}${apiRoutes.publicRegisterRecipientUnblock
        .replace("{inviteId}", inviteId)
        .replace("{recipientId}", data?.id)}`;
    } else {
      apiUrl = `${API_BASE_URL}${apiRoutes.publicRegisterRecipientBlock
        .replace("{inviteId}", inviteId)
        .replace("{recipientId}", data?.id)}`;
    }
    axios
      .post(apiUrl, {}, config)
      .then((res) => {
        if (data?.isBlocked) {
          addToast(
            res?.data?.data?.message ??
              DISPLAY_TEXTS.RECIPIENT_INVITE_UNBLOCK_SUCESS,
            { appearance: "success" }
          );
        } else {
          addToast(
            res?.data?.data?.message ??
              DISPLAY_TEXTS.RECIPIENT_INVITE_BLOCK_SUCESS,
            { appearance: "success" }
          );
        }
        recipientsList?.refetch && recipientsList.refetch();
      })
      .catch((err) => {
        if (data?.isBlocked) {
          addToast(
            err?.response?.data?.errors[0]?.detail ??
              DISPLAY_TEXTS.RECIPIENT_INVITE_UNBLOCK_FAILED,
            { appearance: "error" }
          );
        } else {
          addToast(
            err?.response?.data?.errors[0]?.detail ??
              DISPLAY_TEXTS.RECIPIENT_INVITE_BLOCK_FAILED,
            { appearance: "error" }
          );
        }
      });
  };

  const getProfilesUsed = () => {
    setProfilesLoading(true);
    let apiUrl;
    apiUrl = `${API_BASE_URL}${apiRoutes.publicRegisterRecipientProfiles
      .replace("{inviteId}", inviteId)
      .replace(
        "{recipientId}",
        recipientId
      )}&page[number]=${profilesPage}&page[size]=5`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setProfilesLoading(false);
        setProfilesList(res?.data);
      })
      .catch((err) => {
        setProfilesLoading(false);
        setProfilesList([]);
      });
  };

  useEffect(() => {
    if (recipientId) {
      getProfilesUsed();
    }
  }, [recipientId, profilesPage]);

  const viewProfilesUsed = (data) => {
    setRecipientId(data?.id);
    setShowProfilesList(true);
  };

  const getEvent = (mode) => {
    if (mode.mode === "resendRecipientInvite") {
      openResendConfirmationModal(mode?.rowData?.id);
    } else if (
      mode.mode === "blockRecipientInvite" ||
      "unBlockRecipientInvite"
    ) {
      openBlockConfirmationModaL(mode?.rowData);
    }
  };

  const getProfileEvents = (mode) => {
    if (mode.mode === "view") {
      viewProfile(mode?.rowData);
    }
  };

  const renderProfileCard = (rowData) => (
    <ProfileCard
      data={rowData}
      mode="self-registration-recipient-invite"
      actions={userRoleDetails}
      actionsToParent={(mode) => getEvent({ mode, rowData })}
      fields={[
        {
          name: "Invited Time",
          value: getFormattedDateTime(rowData?.createdAt),
        },
        {
          name: "Blocked",
          value: rowData?.isBlocked ? "Yes" : "No",
        },
        {
          name: "Profiles Used",
          value:
            rowData?.registeredProfilesCount === 0 ? (
              <span>{rowData?.registeredProfilesCount}</span>
            ) : (
              <span
                className="pointer"
                onClick={() => viewProfilesUsed(rowData)}
              >
                {rowData?.registeredProfilesCount}
              </span>
            ),
          hide: "md",
        },
      ]}
    />
  );

  const renderProfileListCard = (rowData) => (
    <ProfileCard
      data={rowData}
      mode="self-registration-recipient-profiles"
      actions={userRoleDetails}
      actionsToParent={(mode) => getProfileEvents({ mode, rowData })}
      fields={[
        {
          name: "Name",
          value: rowData?.attributes?.profile?.fullName,
        },
        {
          name: "Email",
          value: (
            <span className="email-text">
              {rowData?.attributes?.profile?.email}
            </span>
          ),
        },
        {
          name: "Created Time",
          value: (
            <span className="email-text">
              {getFormattedDateTime(rowData?.attributes?.createdAt)}
            </span>
          ),
        },
        {
          name: "Type",
          value: rowData?.attributes?.type === 0 ? "New" : "Existing",
        },
      ]}
    />
  );

  const handleRowsPerPageChange = (rows) => setRowsPerPage(rows);
  const handleCurrPageChange = (page) => setCurrPage(page);
  const handleProfilePageChange = (page) => setProfilesPage(page);

  let menuRef = useRef();
  useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      if (
        event.target.className !== "user-role-action-icons" &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setTableUserId("");
      }
    });
  });
  const [tableUserId, setTableUserId] = useState("");

  const showHideContextMenu = (id) => {
    setTableUserId(id);
  };

  const showContextActionMenu = (invite) => {
    const hasInviteRecipientResendPermission = checkModuleGeneralPermission(
      userRoleDetails,
      "recipients",
      "resend_recipient_invite",
      invite
    );

    const hasInviteRecipientUnblockPermission = checkModuleGeneralPermission(
      userRoleDetails,
      "recipients",
      "unblock_recipients",
      invite
    );
    const hasInviteRecipientBlockPermission = checkModuleGeneralPermission(
      userRoleDetails,
      "recipients",
      "block_recipients",
      invite
    );

    if (
      !hasInviteRecipientResendPermission &&
      !hasInviteRecipientBlockPermission &&
      !hasInviteRecipientUnblockPermission
    )
      return null;
    return (
      <div
        className={`contextMenu ${
          inviteDetails?.attributes?.status != 1 ? "disabled" : ""
        }`}
      >
        {tableUserId === invite?.id && (
          <ContextMenuContentWrapper
            showContextMenu={tableUserId === invite?.id}
            handleContextMenuClose={() => setTableUserId("")}
          >
            <ul ref={menuRef}>
              {hasInviteRecipientBlockPermission && !invite.isBlocked && (
                <li onClick={() => openBlockConfirmationModaL(invite)}>
                  <button>
                    <i className="iconsminds-mail-block user-role-action-icons text-danger" />
                    Block
                  </button>
                </li>
              )}
              {hasInviteRecipientUnblockPermission && invite.isBlocked && (
                <li onClick={() => openBlockConfirmationModaL(invite)}>
                  <button>
                    <i className="iconsminds-mail-forward user-role-action-icons primary" />
                    Unblock
                  </button>
                </li>
              )}
              {hasInviteRecipientResendPermission && !invite.isBlocked && (
                <li onClick={() => openResendConfirmationModal(invite?.id)}>
                  <button>
                    <i className="iconsminds-refresh resend user-role-action-icons primary"></i>
                    Resend
                  </button>
                </li>
              )}
            </ul>
          </ContextMenuContentWrapper>
        )}
        <span
          className="user-role-action-icons"
          onClick={() => showHideContextMenu(invite.id)}
        >
          <i></i>
        </span>
        <ReactTooltip place="top" type="dark" effect="solid" />
      </div>
    );
  };

  const columns = [
    {
      name: "Email",
      minWidth: 200,
      selector: (row) => row["emailAddresss"],
      cell: (row) => renderProfileCard(row),
    },
    {
      name: "Invited Time",
      minWidth: 200,
      hide: "md",
      selector: (row) => row["createdAt"],
      cell: (row) => getFormattedDateTime(row?.createdAt),
    },
    {
      name: "Blocked",
      minWidth: 150,
      selector: (row) => row["isBlocked"],
      cell: (row) => (
        <div>
          <PillText
            label={row?.isBlocked ? "Yes" : "No"}
            type={String(!row?.isBlocked)}
          />
        </div>
      ),
      hide: "md",
    },
    {
      name: "Profiles Used",
      minWidth: 150,
      center: true,
      selector: (row) => row["registeredProfilesCount"],
      cell: (row) =>
        row?.registeredProfilesCount === 0 ? (
          <span>{row?.registeredProfilesCount}</span>
        ) : (
          <span className="pointer" onClick={() => viewProfilesUsed(row)}>
            {row?.registeredProfilesCount}
          </span>
        ),
      hide: "md",
    },
    {
      name: "Actions",
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      center: true,
      cell: (invite) => showContextActionMenu(invite),
      hide: "md",
      right: true,
    },
  ];

  const handleBlockedFilterChange = (selectedOption) => {
    setIsBlockedFilter(selectedOption);
  };

  const FilterSection = () => {
    return (
      <div className="advance-filter">
        <div>
          <span>Blocked</span>
          <div>
            <Select
              placeholder="Select"
              className="cutomSelect"
              classNamePrefix="react-select"
              options={[
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
              ]}
              value={blockedFilter}
              onChange={handleBlockedFilterChange}
            />
          </div>
        </div>
      </div>
    );
  };

  const onSearchInputChange = (searchQuery) => {
    setSearchQueryString(searchQuery);
    const updatedFilters = { ...filters };
    updatedFilters.search = searchQuery;
    setFilters(updatedFilters);
    setactivePage(1);
    setCurrPage(1);
  };

  const handleResetFilter = (e) => {
    showFilter(false);
    setIsBlockedFilter("");
    const updatedFilters = { ...filters };
    updatedFilters.is_blocked = "";
    setFilters(updatedFilters);
    setactivePage(1);
  };

  const handleApplyFilter = (e) => {
    showFilter(false);
    const updatedFilters = { ...filters };
    updatedFilters.is_blocked = blockedFilter.value;
    setFilters(updatedFilters);
    setactivePage(1);
  };

  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };

  const profileColumns = [
    {
      name: "ProfileID",
      minWidth: 100,
      selector: (row) => row?.attributes?.profile?.profileId,
      cell: (row) => renderProfileListCard(row),
    },
    {
      name: "Name",
      minWidth: 150,
      hide: "md",
      cell: (row) => <span>{row?.attributes?.profile?.fullName}</span>,
    },

    {
      name: "Email",
      minWidth: 200,
      cell: (row) => <span>{row?.attributes?.profile?.email}</span>,
      hide: "md",
    },
    {
      name: "Created Time",
      minWidth: 180,
      hide: "md",
      cell: (row) => (
        <span>{getFormattedDateTime(row?.attributes?.createdAt)}</span>
      ),
    },
    {
      name: "Type",
      minWidth: 100,
      cell: (row) => (
        <span>{row?.attributes?.type === 0 ? "New" : "Existing"}</span>
      ),
      hide: "md",
    },
    {
      name: "Actions",
      sortable: false,

      center: true,
      maxWidth: 100,
      minWidth: 100,
      cell: (data) => (
        <>
          <span
            className="simple-icon-eye user-role-action-icons view"
            onClick={() => viewProfile(data)}
          ></span>
        </>
      ),
      right: true,
      hide: "md",
    },
  ];

  const viewProfile = (data) => {
    history.push({
      pathname: VW_ROUTES.PERSON_PROFILE_VIEW,
      search: `?id=${data?.attributes?.profile?.id}`,
      state: {
        from: history.location?.pathname,
      },
    });
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Breadcrumb
            title="Self Registration"
            breadcrumbItem={inviteDetails?.attributes?.description}
            url={VW_ROUTES.SELF_REGISTRATION_INVITES}
          />
          <div className="page-header">
            <h1>Recipients List</h1>
            <div className="applicantFilter">
              <div className="desktopSearch">
                <SearchBar
                  id="search-desktop"
                  onSearchInputChange={onSearchInputChange}
                  popstateText={searchQueryString}
                />
              </div>
              <div
                className={
                  showMobileDataFilter ? "table-filter active" : "table-filter"
                }
              >
                <div
                  className="filter-hide"
                  onClick={() => showFilter(false)}
                ></div>
                <div className="filter-form">
                  <div className="mobile-search">
                    <SearchBar
                      id="search-mobile"
                      onSearchInputChange={onSearchInputChange}
                      popstateText={searchQueryString}
                    />
                  </div>
                  <h4 className="advanced-filter-heading">Advanced Search</h4>
                  <FilterSection />
                  <div className="d-flex w-100 align-items-center justify-content-end mt-3">
                    <button
                      className="btn btn-primary mr-2"
                      onClick={(e) => {
                        handleResetFilter(e);
                      }}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-secondary m-0"
                      onClick={(e) => {
                        handleApplyFilter(e);
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
              <div
                className={`tableFilterButton rightAlign  ${
                  filterApplied ? "btn-secondary" : ""
                }`}
                title="Advanced Search"
                onClick={() => showFilter(true)}
              >
                <i className="iconsminds-filter-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="card">
            <div
              className={
                recipientsList.isLoading || recipientsList.isFetching || loading
                  ? "card-body dataTableOuter table-loader modal-table"
                  : "card-body dataTableOuter modal-table"
              }
            >
              <DataTable
                keyField="id"
                progressComponent={<p>&nbsp;</p>}
                progressPending={
                  recipientsList.isLoading ||
                  recipientsList.isFetching ||
                  loading
                }
                columns={columns}
                data={recipientsList?.data}
                paginationServer={true}
                pagination={true}
                paginationPerPage={rowsPerPage}
                onChangeRowsPerPage={handleRowsPerPageChange}
                onChangePage={handleCurrPageChange}
                paginationTotalRows={recipientsList?.meta?.pagination.count}
                paginationDefaultPage={activePage}
                striped={true}
              />
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        show={showResendConfirmation}
        header={<b>Confirm Resend</b>}
        content={
          <>
            <p>
              Are you sure you want to resend the "invitation" to recipient?
            </p>
          </>
        }
        onSubmitCallback={() => {
          handleResendRecipientInvite(selectedDetails);
        }}
        onCloseCallback={closeResendConfirmationModal}
        submitButtonText="Resend"
      />
      <ModalComponent
        show={showBlockConfirmation}
        header={
          <b>
            {selectedDetails?.isBlocked ? "Confirm Unblock" : "Confirm Block"}
          </b>
        }
        content={
          <>
            <p>
              {selectedDetails?.isBlocked
                ? "Are you sure you want to unblock the recipient?"
                : "Are you sure you want to block the recipient?"}
            </p>
          </>
        }
        onSubmitCallback={() => {
          handleBlockRecipientInvite(selectedDetails);
        }}
        onCloseCallback={closeBlockConfirmationModal}
        submitButtonText="Yes"
        cancelButtonText="No"
      />

      <ModalComponent
        customClass={"modal-lg profiles-modal"}
        show={showProfilesList}
        header={<b>Profiles Used</b>}
        content={
          <>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div
                    className={
                      profilesLoading
                        ? "card-body dataTableOuter table-loader modal-table"
                        : "card-body dataTableOuter modal-table"
                    }
                  >
                    <DataTable
                      keyField="id"
                      progressComponent={<p>&nbsp;</p>}
                      progressPending={profilesLoading}
                      columns={profileColumns}
                      data={profilesList?.data}
                      paginationServer={true}
                      pagination={true}
                      paginationPerPage={5}
                      paginationRowsPerPageOptions={[5]}
                      onChangePage={handleProfilePageChange}
                      paginationTotalRows={
                        profilesList?.meta &&
                        profilesList?.meta?.pagination?.count
                      }
                      paginationComponentOptions={paginationComponentOptions}
                      paginationDefaultPage={profileActivePage}
                      striped={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        onSubmitCallback={() => {
          setShowProfilesList(false);
          setRecipientId(null);
        }}
        onCloseCallback={() => {
          setShowProfilesList(false);
          setRecipientId(null);
        }}
        submitButtonText="Close"
        hideCancel={true}
      />
    </>
  );
};

export default PublicRegistrationRecipients;
